"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type MouseEvent, type ReactNode, useContext } from "react";
import { useCurrentTime } from "@/hooks/use-current-time";
import { getVolunteerRegistrationView, isVolunteerRegistrationClosed } from "../_registration";
import type { VolunteerRegistration } from "../_types";
type RegistrationContext = {
  registration: VolunteerRegistration;
  view: ReturnType<typeof getVolunteerRegistrationView>;
  checkBeforeNavigation: (event: MouseEvent<HTMLAnchorElement>) => void;
};
const VolunteerRegistrationContext = createContext<RegistrationContext | null>(null);
export function VolunteerRegistrationProvider(t0) {
  const $ = _c(14);
  const {
    registration,
    year,
    children
  } = t0;
  const {
    now,
    refreshCurrentTime
  } = useCurrentTime();
  let t1;
  if ($[0] !== refreshCurrentTime || $[1] !== registration) {
    t1 = function checkBeforeNavigation(event) {
      const currentTime = refreshCurrentTime();
      if (!registration.url || isVolunteerRegistrationClosed(registration.closeDate, currentTime)) {
        event.preventDefault();
      }
    };
    $[0] = refreshCurrentTime;
    $[1] = registration;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const checkBeforeNavigation = t1;
  let t2;
  if ($[3] !== now || $[4] !== registration || $[5] !== year) {
    t2 = getVolunteerRegistrationView(registration, year, now);
    $[3] = now;
    $[4] = registration;
    $[5] = year;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== checkBeforeNavigation || $[8] !== registration || $[9] !== t2) {
    t3 = {
      registration,
      view: t2,
      checkBeforeNavigation
    };
    $[7] = checkBeforeNavigation;
    $[8] = registration;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== t3) {
    t4 = <VolunteerRegistrationContext value={t3}>{children}</VolunteerRegistrationContext>;
    $[11] = children;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export function useVolunteerRegistration() {
  const context = useContext(VolunteerRegistrationContext);
  if (!context) {
    throw new Error("Volunteer registration controls require VolunteerRegistrationProvider.");
  }
  return context;
}